"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'email.activation.subject': 'Attiva il tuo account',
    'email.activation.title': 'Benvenuto in IntHub!',
    'email.activation.text': 'Grazie per esserti registrato in IntHub. Per completare la registrazione e attivare il tuo account, clicca il pulsante qui sotto.',
    'email.activation.button': 'Attiva Account',
};
